(() => {
  const homeSearch = document.querySelector('#dm-home-query');
  if (homeSearch) {
    const mobile = matchMedia('(max-width: 767px)');
    const updatePlaceholder = () => {
      homeSearch.placeholder = mobile.matches ? homeSearch.dataset.placeholderMobile : homeSearch.dataset.placeholderDesktop;
    };
    updatePlaceholder();
    mobile.addEventListener('change', updatePlaceholder);
  }

  // The native Shopify product form handles availability, errors and drawer refresh.
  document.addEventListener('change', (event) => {
    const radio = event.target.closest('[data-dm-purchase] input[type="radio"]');
    if (!radio) return;
    const choice = radio.closest('[data-dm-purchase]');
    const form = choice.closest('form');
    const variant = form.querySelector('input[name="id"]');
    if (!variant) return;
    variant.value = radio.value;
    const submitLabel = form.querySelector('[name="add"] > span');
    if (submitLabel) submitLabel.textContent = radio.dataset.kind === 'bundle' ? choice.dataset.bundleLabel : choice.dataset.singleLabel;
    const quantity = form.querySelector('[name="quantity"]');
    if (quantity) quantity.value = 1;
    const sticky = document.querySelector(`sticky-atc-bar[data-product-id="${choice.dataset.productId}"]`);
    if (sticky) {
      const select = sticky.querySelector('select[name="id"]');
      if (select) {
        if (![...select.options].some((option) => option.value === radio.value)) {
          select.add(new Option(choice.dataset.bundleLabel, radio.value));
        }
        select.value = radio.value;
      }
      const stickyLabel = sticky.querySelector('[name="add"] > span');
      if (stickyLabel) stickyLabel.textContent = submitLabel.textContent;
      sticky.querySelectorAll('.f-price-item--regular, .f-price-item--sale').forEach((price) => {
        price.textContent = radio.dataset.price;
      });
      const stickyQuantity = sticky.querySelector('[name="quantity"]');
      if (stickyQuantity) stickyQuantity.value = 1;
    }
  });

})();
